const state = {
  predefAnalyseType: '',
  predefAnalyseBackground: ''
}

const mutations = {
  merkPositionering (state) {
    state.predefAnalyseType = 'merkpositionering'
  },
  merkDoelgroep (state) {
    state.predefAnalyseType = 'merkdoelgroep'
  },
  merkCommunicatieStrategie (state) {
    state.predefAnalyseType = 'merkcommunicatie'
  },
  marketingTrends (state) {
    state.predefAnalyseType = 'marketingtrends'
  },
  resetPredefType (state) {
    state.predefAnalyseType = ''
  },
  setBGBlack (state) {
    state.predefAnalyseBackground = 'black'
  },
  setBGWhite (state) {
    state.predefAnalyseBackground = 'white'
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
